import {graphql} from '~/graphql-react-query/';

export const ViewerQuery = graphql(`
    query ViewerQuery($options: ViewerQueryOptions) {
        viewer(options: $options) {
            id
            userOnboardingInfo {
                isAustraliaOnboarded
            }
            teams {
                id
                name
                role
                products {
                    product
                    industryIds
                    industries
                    mediaTypes
                    mediaTypeIds
                    status
                    metadata
                    country
                }
                trialExpired
                hasTrialTeamName
                requestedNzTrial
                downloadCount
            }
            user {
                firstname
                id
                lastname
                name
                username
                createdAt
                registrationStatus
                sessionMetadata
            }
        }
    }
`);
